import * as yup from 'yup'

export const schema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required()
    .min(3, 'Nome deve ter no mínimo 3 caracteres'),
  responsiblesIds: yup.array(),
})

export default schema
